import {  useState } from 'react';
import { AiFillEdit } from 'react-icons/ai';

const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL


const Notes = ({ notes, setNotes, currentUser, jobId }) => {
    const [editNotes, setEditNotes] = useState(false);
    const [tempNotes, setTempNotes] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();
        const n = tempNotes ? tempNotes : notes
        const res = await fetch(`${REACT_APP_BACKEND_URL}/jobs/notes/update/${jobId}/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Token ${currentUser.token}`
            },
            body: JSON.stringify({
                notes: n
            })
        })
        const data = await res.json()
        console.log(data)
        if (data.status_code === 'success') {
            setNotes(n)
            setEditNotes(false)
        }
    };
    return (
        <div className='misc-box-container'>
            <div className=''>
                <h2>Notes <AiFillEdit className='cursor' onClick={() => setEditNotes(true)} /></h2>
                {editNotes ?
                    <div>
                        <textarea className='keywords__textarea' rows={16} defaultValue={notes} onChange={(e) => { setTempNotes(e.target.value) }}>
                        </textarea>
                        <div>
                            <button onClick={(e) => handleSubmit(e)}>Save</button>
                            <button onClick={() => setEditNotes(false)}>Cancel</button>
                        </div>
                    </div>
                    :
                    <p>
                        {notes}
                    </p>
                }
            </div>
        </div>
    )
};
export default Notes;